<template>
  <div class="calendar">
    <div class="row calendar-header">
      <div class="calendar-navigation" v-on:click.stop="navigateCalendar(-1)">
        <img src="../../assets/img/back.svg" alt="back img" class="calendar-navigation-icon back">
      </div>
      <div class="month-name">{{month}}</div>
      <div class="calendar-navigation" :class="(!isForwardEnabled) ? 'disabled' : ''" v-on:click.stop="navigateCalendar(1)">
        <img v-if="isForwardEnabled" src="../../assets/img/back.svg" alt="back img" class="calendar-navigation-icon forward">
        <img v-else src="../../assets/img/back-disabled.svg" alt="back img" class="calendar-navigation-icon forward">
      </div>
    </div>
    <div class="row">
      <div v-for="(day, index) in weekDays" :key="index">{{$t('DAYABBRV' + day.text.toUpperCase())}}</div>
    </div>
    <div class="row days-row" v-for="(row, index) in monthDays" :key="index">
      <div v-for="(day, index) in row" class="date-day" :class="getDayClass(day)" v-on:click.stop="changeDate(day)" :key="index">{{day.displayValue}}</div>
    </div>
  </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';

import moment from 'moment-timezone';

export default {
    name: 'CalendarResults',
    props: ['otherStartDate'],
    data()
    {
        return {
            previewDate: moment(15, 'DD'),
            weekDays: [
                {
                    key: '1',
                    text: 'MON',
                },
                {
                    key: '2',
                    text: 'TUE',
                },
                {
                    key: '3',
                    text: 'WED',
                },
                {
                    key: '4',
                    text: 'THU',
                },
                {
                    key: '5',
                    text: 'FRI',
                },
                {
                    key: '6',
                    text: 'SAT',
                },
                {
                    key: '0',
                    text: 'SUN',
                },
            ],
            monthDays: [],
        };
    },
    created()
    {
        const me = this;
        me.calculateCalendar();
    },
    watch:
    {
        startDate()
        {
            const me = this;
            if (me.otherStartDate === undefined)
            {
                me.calculateCalendar();
            }
        },
        otherStartDate(val)
        {
            const me = this;
            if (val !== undefined)
            {
                me.calculateCalendar();
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'startDate',
        ]),
        month()
        {
            const me = this;

            let month = moment(me.previewDate).format('MMM').toUpperCase();

            month = me.$t(`MONTH_${month}`);

            return `${month} ${moment(me.previewDate).format('YYYY')}`;
        },
        isForwardEnabled()
        {
            const me = this;
            if (me.properStartDate === undefined
            || (me.previewDate.year() >= moment().year()
            && me.previewDate.get('month') >= moment().get('month')))
            {
                return false;
            }
            return true;
        },
    },
    methods:
    {
        ...mapActions([
            'selectDate',
        ]),
        getDayClass(day)
        {
            const dayActive = (day.active) ? 'active' : '';
            return ((day.disabled) ? 'disabled' : dayActive);
        },
        navigateCalendar(val)
        {
            const me = this;

            if (!me.isForwardEnabled && val === 1)
            {
                return;
            }

            let month = moment(me.previewDate).get('month') + val;
            let year = moment(me.previewDate).get('year');

            if (month < 0)
            {
                month = 11;
                year -= 1;
            }
            else if (month > 11)
            {
                month = 0;
                year += 1;
            }

            me.previewDate = moment({ year, month, day: 15 });
            me.calculateCalendar();
        },
        changeDate(day)
        {
            const me = this;

            if (day.disabled === true)
            {
                return;
            }

            const date = moment(me.$formatToLocalDate(moment(day.date))).set({ hours: 0, minutes: 0, seconds: 0 });

            let end = moment(date).add(1, 'd');
            end = moment.utc(end);

            const params = {
                start: moment.utc(date),
                end,
            };

            if (me.otherStartDate !== undefined)
            {
                me.$emit('selectDate', date);
            }
            else
            {
                me.selectDate(params);
            }
        },
        calculateCalendar()
        {
            const me = this;

            const setDate = moment(me.$formatToLocalDate(moment.utc(me.previewDate))).format();
            const startDateFormatted = moment.utc(me.$formatToLocalDate(moment(me.properStartDate())))
                .format('YYYY-MM-DD');

            let startDayMonth = moment(setDate).startOf('month').format('d') - 1;
            let endDayMonth = moment(setDate).endOf('month').format('d') - 1;

            if (startDayMonth === -1)
            {
                startDayMonth = 6;
            }
            if (endDayMonth === -1)
            {
                endDayMonth = 6;
            }

            const daysInMonth = moment(setDate).daysInMonth();
            const startDate = moment.utc(setDate).startOf('month');
            const endDate = moment.utc(setDate).endOf('month');
            let i;
            let date = moment().utc();
            const currentDayOfYear = moment().dayOfYear();
            const currentYear = date.year();

            const days = [];
            for (i = startDayMonth; i > 0; i -= 1)
            {
                date = moment.utc(startDate).subtract(i, 'days');

                days.push({
                    date,
                    displayValue: '',
                    active: '',
                    disabled: true,
                });
            }

            for (i = 0; i < daysInMonth; i += 1)
            {
                date = moment.utc(startDate).add(i, 'days');
                const dateDayOfYear = moment(me.$formatToLocalDate(moment.utc(date))).dayOfYear();

                days.push({
                    date,
                    displayValue: date.format('DD'),
                    active: (date.format('YYYY-MM-DD') === startDateFormatted) ? 'active' : '',
                    disabled: !!((date.year() >= currentYear && currentDayOfYear < dateDayOfYear)),
                });
            }

            let x = 1;
            for (i = endDayMonth; i < 6; i += 1)
            {
                date = moment.utc(endDate).add(x, 'days');

                days.push({
                    date,
                    displayValue: '',
                    active: '',
                    disabled: true,
                });
                x += 1;
            }

            me.monthDays = [];

            let j; let temparray; const chunk = 7;
            for (i = 0, j = days.length; i < j; i += chunk)
            {
                temparray = days.slice(i, i + chunk);
                me.monthDays.push(temparray);
            }
        },
        properStartDate()
        {
            const me = this;
            return (me.otherStartDate !== undefined) ? me.otherStartDate : me.startDate;
        },
    },
};
</script>
